/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of notification event.
 * @export
 */
export const NotificationEventType = {
    ConnectionCreated: 'connection.created',
    ConnectionError: 'connection.error',
    ConnectionRefreshed: 'connection.refreshed',
    ConnectionUpdated: 'connection.updated',
    ConnectionDeleted: 'connection.deleted',
    InstallationCreated: 'installation.created',
    InstallationUpdated: 'installation.updated',
    InstallationDeleted: 'installation.deleted',
    ReadSchedulePaused: 'read.schedule.paused',
    ReadBackfillDone: 'read.backfill.done',
    ReadBackfillError: 'read.backfill.error',
    ReadTriggeredDone: 'read.triggered.done',
    ReadTriggeredError: 'read.triggered.error',
    WriteAsyncDone: 'write.async.done',
    SubscribeCreateError: 'subscribe.create.error',
    SubscribeUpdateError: 'subscribe.update.error',
    SubscribeDeleteError: 'subscribe.delete.error',
    SubscribeCreateSuccess: 'subscribe.create.success',
    SubscribeUpdateSuccess: 'subscribe.update.success',
    SubscribeDeleteSuccess: 'subscribe.delete.success',
    DestinationWebhookDisabled: 'destination.webhook.disabled',
    DestinationDeliveryError: 'destination.delivery.error'
} as const;
export type NotificationEventType = typeof NotificationEventType[keyof typeof NotificationEventType];


export function NotificationEventTypeFromJSON(json: any): NotificationEventType {
    return NotificationEventTypeFromJSONTyped(json, false);
}

export function NotificationEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationEventType {
    return json as NotificationEventType;
}

export function NotificationEventTypeToJSON(value?: NotificationEventType | null): any {
    return value as any;
}

